<template>
    <div class="countdown" :class="{'danger': isDanger, 'warning': isWarning}">
        <div>
            <p class="reservation">RESERVATION</p>
            <p v-text="clockText"></p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "count-down",

        props: {
            expiry: { required: true },
            redirect: { required: false }
        },

        data() {
            return {
                timer: null,
                clockText: null,
                isWarning: false,
                isDanger: false
            }
        },

        mounted() {
            this.updateClock()

            this.timer = setInterval(this.updateClock,1000);
        },

        methods: {
            updateClock(){
                let timeToExpiry = moment.duration(moment(this.expiry).diff(moment()))
                let seconds = Math.floor( (timeToExpiry/1000) % 60 );
                let minutes = Math.floor( (timeToExpiry/1000/60) % 60 );

                if(minutes < 0 && seconds < 0){
                    this.clockText = 'Udløbet'
                } else {
                    if(minutes == 0){
                        if(seconds > 30){
                            this.isWarning = true
                        } else {
                            this.isWarning = false
                            this.isDanger = true
                        }
                    }

                    this.clockText = minutes + ':' + (seconds > 9 ? seconds : '0' + seconds)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .countdown {
        position:absolute;
        top:1rem;
        right:1rem;
        border-radius:50%;
        background-color:#77c0a4;
        width: 7rem;
        height: 7rem;
        transform:rotate(10deg);
        color:#fff;
        font-weight:bold;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 2px 5px 5px 0px rgba(0,0,0,0.19);
        text-align:center;
        z-index:1504;
        font-size:2rem;
        line-height: 2rem;
        transition: background 5s;

        .reservation {
            font-size:.6rem;
            line-height:.6rem;
        }

        &.warning {
            background: #ceb000;
        }

        &.danger {
            background: #b20d00;
        }
    }
</style>